import {DeviceType} from '@birco/rainmesh-api';
import {MapConstants} from '../constants/map-constants';
import {divIcon, DivIcon} from 'leaflet';

type MapMarkerStatus = 'default' | 'favorite' | 'outOfService';

export function getMapIcon(
  type: DeviceType | undefined | null,
  status: MapMarkerStatus = 'default',
  isSelected: boolean = false,
): DivIcon {
  const pinUrl = getMapPinUrl(status);
  const iconUrl = getMapDeviceIconUrl(type);
  const selectedClass = isSelected ? ' map-marker-icon--selected' : '';
  const selectedWrapperClass = isSelected ? ' map-marker-icon__wrapper--selected' : '';

  return divIcon({
    ...MapConstants.IconOptions,
    className: `map-marker-icon${selectedClass}`,
    html: `
      <div class="map-marker-icon__wrapper${selectedWrapperClass}">
        <img class="map-marker-icon__pin" src="${pinUrl}" alt="" aria-hidden="true">
        <img class="map-marker-icon__device" src="${iconUrl}" alt="" aria-hidden="true">
      </div>
    `,
  });
}

function getMapPinUrl(status: MapMarkerStatus): string {
  switch (status) {
    case 'favorite':
      return 'assets/icons/map/ic_map_pin_favorite.svg';
    case 'outOfService':
      return 'assets/icons/map/ic_map_pin_out_of_service.svg';
    default:
      return 'assets/icons/map/ic_map_pin_default.svg';
  }
}

function getMapDeviceIconUrl(type: DeviceType | undefined | null): string {
  switch (type) {
    case DeviceType.DISTANCE:
      return 'assets/icons/ic_distance.svg'
    case DeviceType.FLOW:
      return 'assets/icons/ic_flow.svg'
    case DeviceType.SOIL:
      return 'assets/icons/ic_water_percent.svg'
    case DeviceType.WEATHERSTATION:
      return 'assets/icons/ic_weatherstation.svg'
    case DeviceType.VALVE:
      return 'assets/icons/ic_ventile.svg'
    case DeviceType.PUMP:
      return 'assets/icons/ic_pump.svg'
    case DeviceType.UNKNOWN:
      return 'assets/icons/ic_unknown_device.svg'
    default:
      return 'assets/icons/ic_unknown_device.svg'
  }
}
